export const command: Record<string, string> = {
  'Active alarm': 'Alarme active',
  'Active shifts': 'Vacations en cours',
  'All caught up': 'Tout est à jour',
  'All guards reporting safe': 'Tous les agents sont en sécurité',
  'Checking live alarms': 'Vérification des alarmes en direct',
  'Approved licences that are expired or expire within 30 days.':
    'Licences approuvées expirées ou arrivant à expiration dans les 30 jours.',
  'Awaiting your review': 'En attente de votre examen',
  'Ops Centre summary': 'Résumé du centre des opérations',
  'Coverage gaps': 'Lacunes de couverture',
  'Data unavailable': 'Données indisponibles',
  'Everything that needs your attention, in one place.':
    'Tout ce qui requiert votre attention, au même endroit.',
  'Expired or due within 30 days': 'Expirées ou arrivant à échéance sous 30 jours',
  'Expired {date}': 'Expirée le {date}',
  'Expires {date}': 'Expire le {date}',
  'Field reporting': 'Rapports terrain',
  'In review': 'En cours d’examen',
  'Leave request from {name}': 'Demande de congé de {name}',
  'Licence warnings': 'Alertes de licence',
  'Live guards': 'Agents en direct',
  'Loading command data': 'Chargement des données du centre des opérations',
  'Loading coverage data': 'Chargement des données de couverture',
  'Loading notifications': 'Chargement des notifications',
  'Mark all as read': 'Tout marquer comme lu',
  'Low battery': 'Batterie faible',
  'Needs immediate action': 'Action immédiate requise',
  'Needs more info': 'Informations complémentaires requises',
  'New and updated reports': 'Rapports nouveaux et mis à jour',
  'Next 14 days': '14 prochains jours',
  'No immediate actions need your attention.': 'Aucune action immédiate ne requiert votre attention.',
  'No licence expiry warnings': 'Aucune alerte d’expiration de licence',
  'No recent incident reports': 'Aucun rapport d’incident récent',
  'No recent summary reports': 'Aucun rapport de synthèse récent',
  'No site': 'Aucun site',
  'No-shows': 'Absences à la prise de poste',
  'Notification centre': 'Centre de notifications',
  'Notifications and reports': 'Notifications et rapports',
  'Now': 'Maintenant',
  'Open Duty Board': 'Ouvrir le tableau de service',
  'Open first unread update': 'Ouvrir la première mise à jour non lue',
  'Open||action': 'Ouvrir',
  'Open||report': 'Ouvert',
  'Open response queue': 'Ouvrir la file d’intervention',
  'Operational command': 'Pilotage opérationnel',
  'Operational pulse': 'Pouls opérationnel',
  'Other leave': 'Autre congé',
  'Overrunning': 'En dépassement',
  'Pending leave': 'Congés en attente',
  'Published shifts not started': 'Vacations publiées non commencées',
  'Recent incident and summary reports, ordered by their latest update.':
    'Rapports d’incident et de synthèse récents, classés selon leur dernière mise à jour.',
  'Refresh attempted {time}': 'Actualisation tentée à {time}',
  'Reports to review': 'Rapports à examiner',
  'Review coverage': 'Examiner la couverture',
  'Requests & updates': 'Demandes et mises à jour',
  'Requests awaiting review': 'Demandes en attente d’examen',
  'Respond': 'Intervenir',
  'Security licence': 'Licence de sécurité',
  'Some action feeds are unavailable.': 'Certains flux d’actions sont indisponibles.',
  'Some command data could not be refreshed. Last available values remain visible.':
    'Certaines données du centre des opérations n’ont pas pu être actualisées. Les dernières valeurs disponibles restent visibles.',
  'Summaries': 'Synthèses',
  'Unknown guard': 'Agent inconnu',
  'Unread': 'Non lu',
  'Unread updates': 'Mises à jour non lues',
  'Untitled incident': 'Incident sans titre',
  'Untitled summary': 'Synthèse sans titre',
  'View all': 'Tout voir',
  'New and updated field reports': 'Rapports terrain nouveaux et mis à jour',
  '{count} coverage issue': '{count} problème de couverture',
  '{count} coverage issues': '{count} problèmes de couverture',
  '{count} incident to review': '{count} incident à examiner',
  '{count} incidents to review': '{count} incidents à examiner',
  '{count} item is waiting for you.': '{count} élément vous attend.',
  '{count} items are waiting for you.': '{count} éléments vous attendent.',
  '{count} licence warning': '{count} alerte de licence',
  '{count} licence warnings': '{count} alertes de licence',
  '{count} leave request': '{count} demande de congé',
  '{count} leave requests': '{count} demandes de congé',
  '{count} open position': '{count} poste non pourvu',
  '{count} open positions': '{count} postes non pourvus',
  '{count} report needs review': '{count} rapport doit être examiné',
  '{count} reports need review': '{count} rapports doivent être examinés',
  '{count} unread update': '{count} mise à jour non lue',
  '{count} unread updates': '{count} mises à jour non lues',
  '{name} did not start their shift': '{name} n’a pas commencé sa vacation',
};
